import { styled } from 'styled-components';
import { Utils } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

export const LocationCellContainerStyled = styled.div`
  gap: ${pxToRem(5)};
  ${flexFn('flex-start')}
`;
